var _path, _circle, _circle2, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "474 202 382 294",
    role: "img",
    "aria-label": "Ijarachi",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M498 326 Q665 126 832 326",
    fill: "none",
    stroke: "#0B6B58",
    strokeWidth: 34,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 608,
    cy: 343,
    r: 38,
    fill: "#1F8A70"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 723,
    cy: 343,
    r: 38,
    fill: "#F2A33A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M538 490 A70 70 0 0 1 678 490 Z",
    fill: "#1F8A70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M653 490 A70 70 0 0 1 793 490 Z",
    fill: "#F2A33A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandMark);
export default __webpack_public_path__ + "static/media/brand-mark.b44b62ec36d98eff698f46c75c710a30.svg";
export { ForwardRef as ReactComponent };